import { render, staticRenderFns } from "./FreeDashboardContent.vue?vue&type=template&id=1aed07ff&scoped=true&"
import script from "./FreeDashboardContent.vue?vue&type=script&lang=js&"
export * from "./FreeDashboardContent.vue?vue&type=script&lang=js&"
import style0 from "./FreeDashboardContent.vue?vue&type=style&index=0&id=1aed07ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed07ff",
  null
  
)

export default component.exports